import request from '@/utils/request'

// 查询发票抬头列表
export function languagelist(query) {
  return request({
    url: '/website/websitehome/languageslist',
    method: 'get',
    params: query
  })
}

export function mainimage(id) {
  return request({
    url: '/website/websitehome/mainimage/'+id,
    method: 'get',
  })
}

export function paramsinfo(id) {
  return request({
    url: '/website/websitehome/paramsinfo/'+id,
    method: 'get',
  })
}

export function producttype(query) {
  return request({
    url: '/website/websitehome/producttype/'+query.id,
    method: 'get',
    params: query
  })
}

export function customergroup(query) {
  return request({
    url: '/website/websitehome/customergroup/'+query.id,
    method: 'get',
    params: query
  })
}

export function cooperationpartners(query) {
  return request({
    url: '/website/websitehome/cooperationpartners',
    method: 'get',
    params: query
  })
}
export function websitescreens(query) {
  return request({
    url: '/website/websitehome/websitescreens/'+query.id,
    method: 'get',
    params: query
  })
}

export function customizedsolution(query) {
  return request({
    url: '/website/websitehome/customizedsolution/'+query.id,
    method: 'get',
    params: query
  })
}

export function companytechnology(query) {
  return request({
    url: '/website/websitehome/companytechnology/'+query.id,
    method: 'get',
    params: query
  })
}

export function addfeedback(data) {
  return request({
    url: '/website/websitehome/addfeedback',
    method: 'post',
    data: data
  })
}

